/**
 * @generated SignedSource<<24f98b18c614cf6e8091765b8b79009d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogArticleDeleteButtonFragment$data = {
  readonly __id: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "BlogArticleDeleteButtonFragment";
};
export type BlogArticleDeleteButtonFragment$key = {
  readonly " $data"?: BlogArticleDeleteButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogArticleDeleteButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogArticleDeleteButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "BlogArticle",
  "abstractKey": null
};

(node as any).hash = "e8f128c0f07e715859a3aee4cc2df4cd";

export default node;
